import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import path from 'path';
import {
  Row,
  Col,
  Icon,
  Grid,
  MenuItem,
  PanelBody,
  PanelHeader,
  PanelContainer,
  DropdownButton,
  Button,
  ButtonToolbar,
  Image,
  Modal,
} from '@sketchpixy/rubix';

import FileType from './FileType';
import FileTree from './FileTree';
import UploadModal from '../../component/UploadModal';
import UploadAssetJsonModal from './components/UploadAssetJsonModal';
import CopyModal from '../../component/CopyModal';
import { formatBytes } from '../../common/formatBytes';
import { routeUrl } from '../routeUrl';
import RoleType from '../RoleGroup/Roles/RoleType';
import ServiceType from '../../constants/ServiceType';
import { checkRole } from '../../util/RoleChecker';
import {
  getAssetVersions,
  getServiceName,
  getProfile,
  createAssetVersion,
  deleteAsset,
  getAssetFileList,
} from '../../api/api';

class Upload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      serviceType: null,
      currentAssetVersionId: 1,
      currentVersionCode: 1,
      serviceName: 'Unknown',
      versions: [
        {
          'assetVersionId': 1,
          'assetVersionMin': 1,
          'assetVersionMax': 1000,
          'version': 1,
          'createdTime': '2017-04-12T00:40:35.000Z',
          'updatedTime': '2017-06-08T15:35:07.000Z',
        },
      ],
      folders: [],
      showModal: false,
      showCopyModal: false,
      isCopyable: false,
      currentFolder: '',
      fileList: ['test.png'],
      username: null,
      fileTree: [],
      detail: null,
      showDeleteFilesModal: false,
      showUploadJsonModal: false,
    };
  }

  prompt() {
    vex.dialog.prompt({
      message: 'Type the new version code',
      placeholder: 'version code allows only number',
      callback: (value) => {
        let version = parseInt(value);

        if (isNaN(version) || version <= 0) {
          vex.dialog.alert('Version allows only integer');
          return;
        }

        createAssetVersion(version, this.state.serviceType, (err, result) => {
          if (err) {
            vex.dialog.alert('Create new version code err! please check the code again');
          } else {
            if (result.statusCode > 0) {
              vex.dialog.alert('Create new version code err! please check the code again');
              return;
            }

            vex.dialog.alert('Created successfully!');
            this.getAssetVersions().then((bool) => {
              if (bool) {
                this.setState({
                  currentVersionCode: result.assetVersion.version,
                  currentAssetVersionId: result.assetVersion.assetVersionId,
                }, () => {
                  this.getAllFiles();
                });
              }
            });
          }
        });
      },
    });
  }

  setService(props) {
    let serviceType = props.params.serviceType;
    this.setState({ serviceType }, () => {
      getServiceName(this.state.serviceType, (err, result) => {
        if (err) {
          console.error('grt service name err ', err);
        } else {
          this.setState({ serviceName: result.serviceTypeDisplayName });
        }
      });

      this.getAssetVersions().then((bool) => {
        if (bool) {
          this.getAllFiles();
        }
      });
    });
  }

  getAssetVersions() {
    return new Promise(resolve => {
      getAssetVersions(this.props.params.serviceType, (err, result) => {
        if (err) {
          this.props.router.push(routeUrl.login);
        } else {
          const versions = result.versions;
          let temp = _.orderBy(versions, ['version'], ['desc']); //version 번호 역순으로 정렬
          let version = null;
          if (this.state.currentVersionCode !== 1 && this.state.currentAssetVersionId === 1) {
            version = _.find(versions, { 'version': this.state.currentVersionCode });
          }
          if (!version) {
            version = temp[0];
          }

          this.setState({
            versions: temp,
            currentVersionCode: version.version,
            currentAssetVersionId: version.assetVersionId,
            isCopyable: temp.length > 1,
          }, () => {
            resolve(true);
          });
        }
      });
    });
  }

  componentDidMount() {
    let serviceType = this.props.params.serviceType;
    let versionCode = this.props.params.versionCode;
    if (versionCode) {
      this.setState({
        currentVersionCode: parseInt(versionCode),
      });
    }

    const requiredRoles = [];

    switch (ServiceType.enumValueOf(serviceType)) {
      case ServiceType.RAPAEL_CLINIC:
        requiredRoles.push(RoleType.ASSET_CLINIC);
        requiredRoles.push(RoleType.ASSET_CLINIC_READ_ONLY);
        break;
      case ServiceType.RAPAEL_CLINIC2:
        requiredRoles.push(RoleType.ASSET_CLINIC2);
        requiredRoles.push(RoleType.ASSET_CLINIC2_READ_ONLY);
        break;
      case ServiceType.RAPAEL_HOME:
        requiredRoles.push(RoleType.ASSET_HOME);
        requiredRoles.push(RoleType.ASSET_HOME_READ_ONLY);
        break;
      case ServiceType.COMCOG:
        requiredRoles.push(RoleType.ASSET_COMCOG);
        requiredRoles.push(RoleType.ASSET_COMCOG_READ_ONLY);
        break;
      case ServiceType.COMCOG_ADMIN:
        requiredRoles.push(RoleType.ASSET_COMCOG_ADMIN);
        requiredRoles.push(RoleType.ASSET_COMCOG_ADMIN_READ_ONLY);
        break;
      case ServiceType.COMCOG_PUBLIC:
        requiredRoles.push(RoleType.ASSET_COMCOG_PUBLIC);
        requiredRoles.push(RoleType.ASSET_COMCOG_PUBLIC_READ_ONLY);
        break;
      case ServiceType.SMART_COACH:
        requiredRoles.push(RoleType.ASSET_SMART_COACH);
        requiredRoles.push(RoleType.ASSET_SMART_COACH_READ_ONLY);
        break;
      case ServiceType.SMART_CARE:
        requiredRoles.push(RoleType.ASSET_SMART_CARE);
        requiredRoles.push(RoleType.ASSET_SMART_CARE_READ_ONLY);
        break;
      case ServiceType.SMART_TABLE:
        requiredRoles.push(RoleType.ASSET_SMART_TABLE);
        requiredRoles.push(RoleType.ASSET_SMART_TABLE_READ_ONLY);
        break;
      case ServiceType.B1:
        requiredRoles.push(RoleType.ASSET_B1);
        requiredRoles.push(RoleType.ASSET_B1_READ_ONLY);
        break;
      case ServiceType.B2:
        requiredRoles.push(RoleType.ASSET_B2);
        requiredRoles.push(RoleType.ASSET_B2_READ_ONLY);
        break;
      case ServiceType.SMART_BODY_CHECKER:
        requiredRoles.push(RoleType.ASSET_SMART_BODY_CHECKER);
        requiredRoles.push(RoleType.ASSET_SMART_BODY_CHECKER_READ_ONLY);
        break;
    }

    checkRole(requiredRoles, this.props.router);

    Messenger.options = {
      theme: 'flat',
    };

    this.setService(this.props);

    getProfile((err, result) => {
      if (err) {
        console.error('get user name error!');
      } else {
        this.setState({ username: result.adminUser.adminUserEmail });
      }
    });

    Messenger().post({
      type: 'info',
      message: 'Select Asset Version Code!!!',
      showCloseButton: true,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setService(nextProps);
    }
  }

  copyFilesCallback = () => {
    this.getAllFiles();
    this.hideCopyModal();
  };

  uploadFilesCallback = () => {
    this.getAllFiles();
    this.hideModal();
  };

  makeFileTree(fileTree, dirs, file) {
    if (dirs) {
      let dir = dirs[0];

      let index = _.findIndex(fileTree, function (o) {
        return o.name === dir && o.type === FileType.DIRECTORY;
      });

      let directoryData;
      if (index === -1) {
        directoryData = {
          name: dir,
          type: FileType.DIRECTORY,
          collapsed: true,
          loading: false,
          children: [],
        };
        fileTree.push(directoryData);
      } else {
        directoryData = fileTree[index];
      }

      dirs = _.drop(dirs);
      if (dirs.length > 0) {
        this.makeFileTree(directoryData.children, dirs, file);
      } else {
        let fileData = this.makeFileData(file);
        directoryData.children.push(fileData);
      }
    } else {
      let fileData = this.makeFileData(file);
      fileTree.push(fileData);
    }
  }

  makeFileData(file) {
    const language = file.localeLanguage;
    const region = file.localeRegion;
    const fileData = {
      type: FileType.FILE,
      assetNAssetVersionId: file.assetNAssetVersionId,
      id: file.assetId,
      name: file.fileName,
      size: file.fileSize,
      update: file.updatedTime,
      url: file.fileUrl,
      language,
      region,
    };

    let localPath = file.localPath;
    const localPathList = localPath.split("/");
    let folders = this.state.folders;
    if (localPathList.length > 2) {
      let path = '';
      localPathList.map(localPath => {
        if (localPath !== '') {
          path += `/${localPath}`;
          folders.push(path);
        }
      });
    } else {
      folders.push(localPath);
    }
    this.setState({
      folders: _.uniq(folders),
    });

    return fileData;
  }

  getAllFiles() {
    this.setState({
      detail: null,
    });

    getAssetFileList(this.state.currentAssetVersionId, (err, result) => {
      if (err) {
        console.error('get All File err : ', err);
      } else {
        let assetFileList = result.list;
        let fileTree = [];
        this.setState({
          folders: [],
        });

        assetFileList = _.sortBy(assetFileList, ['localPath', 'fileName', 'localeLanguage', 'localeRegion']);

        assetFileList.forEach(file => {
          let dirs = path.normalize(file.localPath).match(/\/[^\/]+/g);

          this.makeFileTree(fileTree, dirs, file);
        });

        this.setState({
          fileTree,
        });
      }
    });
  }

  changeVersionHandler = (event) => {
    if (event === 'createNew') {
      this.prompt();
    } else {
      this.setState({
        currentVersionCode: event.name,
        currentAssetVersionId: event.id,
      }, () => {
        this.getAllFiles();
      });
    }
  };

  showUploadModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      showModal: true,
    });
  };

  appearCopyModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      showCopyModal: true,
    });
  };

  hideModal = () => {
    this.setState({
      showModal: false,
    });
  };

  hideCopyModal = () => {
    this.setState({
      showCopyModal: false,
    });
  };

  onClickNode = (node) => {
    let deleteButton = '';
    let deleteFileModalTitle = '';
    let deleteFileModalBody = '';
    switch (node.type) {
      case FileType.DIRECTORY:
        deleteButton = 'Delete Directory';
        deleteFileModalTitle = '디렉토리 삭제';
        deleteFileModalBody = (
          <div>
            <h4>디텍토리를 삭제하시겠습니까?</h4>
            <h4>디텍토리를 삭제하면 하위의 모든 파일이 삭제됩니다.</h4>
          </div>
        );
        break;
      case FileType.FILE:
        deleteButton = 'Delete File';
        deleteFileModalTitle = '파일 삭제';
        deleteFileModalBody = (
          <h4>파일을 삭제하시겠습니까?</h4>
        );
        break;
    }
    this.setState({
      detail: node,
      deleteButton,
      deleteFileModalTitle,
      deleteFileModalBody,
    });
  };

  getAllAssetNAssetVersionId(arr, assetNAssetVersionIds) {
    arr.map(value => {
      switch (value.type) {
        case FileType.DIRECTORY:
          this.getAllAssetNAssetVersionId(value.children, assetNAssetVersionIds);
          break;
        case FileType.FILE:
          assetNAssetVersionIds.push(value.assetNAssetVersionId);
          break;
      }
    });
  }

  showDeleteFilesModal = () => {
    this.setState({
      showDeleteFilesModal: true,
    });
  };

  downloadJson = () => {
    getAssetFileList(this.state.currentAssetVersionId, (err, result) => {
      if (err) {
        console.error('get All File err : ', err);
      } else {
        let assetFileList = result.list;
        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(JSON.stringify(assetFileList));
        hiddenElement.target = '_blank';
        hiddenElement.download = 'assets.json';
        hiddenElement.click();

      }
    });

  };

  uploadJson = () => {
    this.setState({
      showUploadJsonModal: true,
    });
  };

  hideUploadJsonModal = () => {
    this.setState({
      showUploadJsonModal: false,
    });
    this.getAllFiles();
  };

  closeDeleteFilesModal = () => {
    this.setState({
      showDeleteFilesModal: false,
    });
  };

  deleteFile = () => {
    let assetNAssetVersionIds = [];
    switch (this.state.detail.type) {
      case FileType.DIRECTORY:
        this.getAllAssetNAssetVersionId(this.state.detail.children, assetNAssetVersionIds);
        break;
      case FileType.FILE:
        assetNAssetVersionIds.push(this.state.detail.assetNAssetVersionId);
        break;
    }

    deleteAsset(assetNAssetVersionIds, (err) => {
      if (err) {
        console.error('delete asset err => ', err);
      } else {
        this.closeDeleteFilesModal();
        this.getAllFiles();
      }
    });
  };

  getDetail() {
    if (this.state.detail === null) {
      return null;
    }

    switch (this.state.detail.type) {
      case FileType.DIRECTORY:
        return (
          <div>
            - &nbsp; Directory name : {this.state.detail.name}<br />
          </div>
        );
      case FileType.FILE: {
        const ext = path.extname(this.state.detail.name);
        let imageFile = false;
        if (ext.match(/\.(jpg|jpeg|png|gif)$/)) {
          imageFile = true;
        }

        return (
          <div>
            - &nbsp; File name : {this.state.detail.name}<br />
            - &nbsp; File size : {formatBytes(this.state.detail.size)}<br />
            - &nbsp; File updated : {
            this.state.detail.update ? moment(this.state.detail.update).toLocaleString() : null
          }<br />
            - &nbsp; Language : {this.state.detail.language}<br />
            - &nbsp; Region: {this.state.detail.region}<br />
            - &nbsp; Download url: <a href={this.state.detail.url} target="__blank">Click here to download</a><br />
            <br />
            {
              imageFile && (
                <Image src={this.state.detail.url} alt={this.state.detail.name} responsive thumbnail />
              )
            }
          </div>
        );
      }
      default:
        return null;
    }
  }

  render() {
    return (
      <div>
        <PanelContainer controls={false} style={{ float: 'left', width: '100%' }}>
          <PanelHeader className="bg-pinkishred fg-white">
            <Grid>
              <Row>
                <Col xs={12}>
                  <h3>
                    {
                      this.state.serviceName ? this.state.serviceName : null
                    } | Asset Version Code : {this.state.currentVersionCode}
                  </h3>
                </Col>
              </Row>
            </Grid>
          </PanelHeader>
          <PanelBody>
            <Grid style={{ paddingBottom: '15px' }}>
              <Row>
                <Col xs={12} style={{ textAlign: 'right' }}>
                  <ButtonToolbar style={{ display: 'inline-block' }}>
                    <DropdownButton
                      pullRight
                      bsStyle="brownishgray"
                      title="Change Asset Version Code"
                      id="dropdown-basic"
                      onSelect={this.changeVersionHandler}
                    >
                      <MenuItem key="createNew" eventKey="createNew">Create New</MenuItem>
                      {
                        this.state.versions.map((obj) => {
                          let data = {
                            id: obj.assetVersionId,
                            name: obj.version,
                          };
                          return (
                            <MenuItem key={obj.assetVersionId} eventKey={data}>{obj.version}</MenuItem>
                          );
                        })
                      }
                    </DropdownButton>
                    <Button bsStyle="brownishgray" onClick={this.showUploadModal}>Upload</Button>
                    {
                      this.state.isCopyable &&
                      (<Button bsStyle="brownishgray" onClick={this.appearCopyModal}>Copy from others</Button>)
                    }
                    <Button bsStyle="brownishgray" onClick={this.uploadJson}>Upload Json</Button>
                    <Button bsStyle="brownishgray" onClick={this.downloadJson}>Download Json</Button>
                  </ButtonToolbar>
                </Col>
              </Row>
              <Row style={{ border: '1px solid #ddd' }}>
                <Col xs={6} style={{ borderRight: '1px solid #ddd', padding: '0 40px' }}>
                  <Grid>
                    <Row>
                      <Col>
                        <h3 style={{ padding: '0 15px 0 15px' }}>
                          <Icon bundle="stroke-gap-icons" glyph="FileBox" className="fg-desaturateddarkblue" />
                          &nbsp; Local Path
                        </h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col style={{ height: 'calc(70vh - 40px)', overflow: 'scroll' }}>
                        <div style={{ padding: '0 15px 40px 15px' }}>
                          <FileTree
                            tree={this.state.fileTree}
                            currentAssetVersionId={this.state.currentAssetVersionId}
                            onClickNode={(node) => this.onClickNode(node)}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Grid>
                </Col>
                <Col xs={6} style={{ padding: '0 40px' }}>
                  <Grid>
                    <Row>
                      <Col>
                        <h3 style={{ padding: '0 15px 0 15px' }}>
                          <Icon bundle="stroke-gap-icons" glyph="Eye" className="fg-desaturateddarkblue" />
                          &nbsp; Detail
                        </h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div style={{ padding: '0 15px 40px 15px' }}>
                          {this.getDetail()}
                          {
                            this.state.detail === null ? null : (
                              <Button
                                bsStyle="deepred" onClick={this.showDeleteFilesModal}
                                style={{ float: 'right' }}
                              >{this.state.deleteButton}</Button>
                            )
                          }
                        </div>
                      </Col>
                    </Row>
                  </Grid>
                </Col>
              </Row>
            </Grid>
          </PanelBody>
        </PanelContainer>
        {
          this.state.isCopyable &&
          (<CopyModal
            showCopyModal={this.state.showCopyModal}
            hideModal={this.hideCopyModal}
            versions={this.state.versions}
            currentVersion={this.state.currentVersionCode}
            currentAssetVersionId={this.state.currentAssetVersionId}
            existAssets={this.state.fileTree.length > 0}
            copyFilesCallback={this.copyFilesCallback}
          />)
        }
        <UploadModal
          showModal={this.state.showModal}
          hideModal={this.hideModal}
          serviceTypeName={this.state.serviceType}
          assetVersionId={this.state.currentAssetVersionId}
          assetVersion={this.state.currentVersionCode}
          username={this.state.username}
          serviceName={this.state.serviceName}
          currentPath={this.state.currentFolder}
          folders={this.state.folders}
          uploadFilesCallback={this.uploadFilesCallback}
        />
        <UploadAssetJsonModal
          showModal={this.state.showUploadJsonModal}
          hideModal={this.hideUploadJsonModal}
          serviceTypeName={this.state.serviceType}
          assetVersionId={this.state.currentAssetVersionId}
          assetVersion={this.state.currentVersionCode}
        />
        <Modal
          show={this.state.showDeleteFilesModal}
          onHide={this.closeDeleteFilesModal}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.deleteFileModalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.deleteFileModalBody}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeDeleteFilesModal}>No</Button>
            <Button bsStyle="deepred" onClick={this.deleteFile}>Yes</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default Upload;



// WEBPACK FOOTER //
// ./src/routes/asset/Upload.js